import moment from 'moment'
import { MessageBox } from 'element-ui'
// delete obj key: value
interface IStringObj {
  [name: string]: string | any[]
}
export const omit = (obj: IStringObj, uselessKeys: string[]) => {
  uselessKeys.forEach(key => {
    delete obj[key]
  })
  return obj
}

// format and filter json data using filterKeys array
export const formatJson = (filterKeys: Array<string>, jsonData: any) =>
  jsonData.map((data: any) => filterKeys.map((key: string) => data[key]))

// reset obj value to '', K: do not need to be set ''
export function resetObjValue2NoneString<T, K extends keyof T>(obj: T, keys: K[]): void {
  let Arr: K[] = Object.keys(obj) as K[]
  for (let index = 0; index < Arr.length; index++) {
    const e = Arr[index]
    if (!keys.includes(e)) {
      obj[e] = ('' as unknown) as T[K]
    }
  }
}
/**
 * check obj value of some key is '', keys: no need to check
 * @param obj 对象
 * @param keys 不需要判断的key集合
 */
export function checkNoneString<T, K extends keyof T>(obj: T, keys: K[]): boolean {
  let Arr: K[] = Object.keys(obj) as K[]
  let inters: K[] = Arr.filter(item => !keys.includes(item))
  return inters.some(item => obj[item] === (('' as unknown) as T[K]))
}

// return variable type
export function getType(v: any): string {
  return Object.prototype.toString
    .call(v)
    .slice(8, -1)
    .toLocaleLowerCase()
}

export function downFile(resBlob: BlobPart, fileName: string, fileType = '.csv', target = '_self') {
  var blob = new Blob([resBlob], {
    type: 'application/vnd.ms-excel;charset=utf-8'
  })
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // 兼容IE/Edge
    window.navigator.msSaveOrOpenBlob(blob, fileName + fileType)
  } else {
    var url = window.URL.createObjectURL(blob)
    var a = document.createElement('a')
    a.href = url
    a.target = target
    a.style.display = 'none'
    a.setAttribute('download', fileName + fileType)
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
  }
}

// judge arr has unique string
export function isUniqueStringArray(v: string[]): boolean {
  let arr: string[] = Object.assign([], v)
  let leng = arr.length
  let newArr = arr.map(item => item.trim())
  let newLeng = [...new Set(newArr)].length
  return newLeng < leng
}

// find obj index in objArr by id
export function findIndexOfObj(v: any, arr: any[]): number | never {
  if (v.id === void 0) {
    throw new Error('params must have a id')
  }
  let index = arr.findIndex(item => item.id === v.id)
  return index
}

// set [[],[]] itemArr last item to [], 取出内层数组最后一项
export function setHighArr2lowArr(list: any[][]): any[] | never[] {
  let t: any[] = deepCopy(list)
  let temp: any[] = []
  t.forEach((item: any) => {
    temp.push(item.pop())
  })
  return temp
}

// deep clone
export function isObj(obj: object) {
  return (typeof obj === 'object' || typeof obj === 'function') && obj !== null
}
export function deepCopy(obj: any, hash = new WeakMap()) {
  if (hash.has(obj)) return hash.get(obj)
  let cloneObj = Array.isArray(obj) ? [] : ({} as any)
  hash.set(obj, cloneObj)
  for (let key in obj) {
    cloneObj[key] = isObj(obj[key]) ? deepCopy(obj[key], hash) : obj[key]
  }
  return cloneObj
}

// compare 2 dataTime of 'yyyy/MM/dd hh:mm:ss' || 'yyyy/MM/dd'
export function compareDate(start: string, end?: string): boolean | void {
  if (start === '') {
    throw new Error('startDate must have a value!')
  }
  if (start && end === '') {
    return true
  }
  if (start && end) {
    let s = new Date(start).getTime()
    let e = new Date(end).getTime()
    return e - s > 0
  }
}

// 计算时间差,并格式化
export function formatTime(start: string, end?: string): string {
  if (!start || !end) {
    return '0'
  } else {
    let s = new Date(start).getTime()
    let e = new Date(end).getTime()
    let gap = e - s
    if (gap < 0) {
      return '0'
    } else {
      let stamp = gap / 1000
      // 相差天数
      let day = Math.floor(stamp / (24 * 3600))
      // 剩余小时数
      let hours = Math.floor((stamp % (24 * 3600)) / 3600)
      // 剩余分钟数
      let minutes = Math.floor(((stamp % (24 * 3600)) % 3600) / 60)
      // 剩余秒数
      let seconds = stamp % 60
      let d = day === 0 ? '' : `${day}d`
      let h = hours === 0 ? '' : `${hours}h`
      let min = minutes === 0 ? '' : `${minutes}min`
      let s = seconds === 0 ? '0s' : `${seconds}s`
      return d + h + min + s
    }
  }
}

// 设置时间间隔
export function setTimeRange(time: number) {
  const end = new Date()
  const start = new Date()
  start.setTime(start.getTime() - time)
  return [start, end]
}

export function timeToString(timestamp: any) {
  var date = new Date(timestamp) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + '/'
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/'
  var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
  var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
  var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  return Y + M + D + h + m + s
}

export function stringToDate(d: any) {
  let date: any = new Date(d)
  let seperator1 = '/'
  let year = date.getFullYear()
  let month: string = (date.getMonth() + 1).toString().padStart(2, '0')
  let strDate: string = date
    .getDate()
    .toString()
    .padStart(2, '0')
  let time = ['getHours', 'getMinutes', 'getSeconds']
    .map(item =>
      date[item]()
        .toString()
        .padStart(2, '0')
    )
    .join(':')
  let currentdate = year + seperator1 + month + seperator1 + strDate + ' ' + time
  return currentdate
}

// repeat a string
function repeatString(n: number, value: string): string {
  return new Array(n + 1).join(value)
}

// return a padding function, padNum: int
export function getPadFunc(padNum: number): Function {
  return function(targetNum: number): string {
    if (typeof targetNum === 'undefined') return '0.' + repeatString(padNum, '0')
    let floatNum = Math.round(targetNum * 10 * padNum) / (10 * padNum)
    let s = floatNum.toString()
    let rs = s.indexOf('.')
    if (rs < 0) {
      rs = s.length
      s += '.'
    }
    while (s.length <= rs + padNum) {
      s += '0'
    }
    return s
  }
}

// 创建事件监听器
export function onEvent(
  element: HTMLElement | Window,
  event: any,
  handler: EventHandlerNonNull,
  useCapture = false
) {
  if (element && event && handler) {
    element && element.addEventListener(event, handler, useCapture)
  }
}
// 销毁事件监听器
export function offEvent(
  element: HTMLElement | Window,
  event: any,
  handler: EventHandlerNonNull,
  useCapture = false
) {
  let el = element
  if (el && event && handler) {
    el.removeEventListener(event, handler, useCapture)
  }
}

/**
 *  递归查找子组件实例
 * @param context 组件实例
 * @param componentName 组件名
 * @return 实例数组
 */
export function findChildComponents(context: any, componentName: string) {
  return context.$children.reduce((components: any, child: any) => {
    if (child.$options.name === componentName) {
      components.push(child)
    }
    const foundChilds = findChildComponents(child, componentName)
    return components.concat(foundChilds)
  }, [])
}

// requestAnimFrame兼容
const requestAnimFrame = (function() {
  return (
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    (window as any).mozRequestAnimationFrame ||
    function(callback) {
      window.setTimeout(callback, 1000 / 60)
    }
  )
})()

// 滚动到指定位置
export function scrollTo(
  el: HTMLElement | Window,
  from = 0,
  to: number,
  duration = 500,
  endCallback: Function
) {
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = requestAnimFrame
  }
  const difference = Math.abs(from - to)
  const step = Math.ceil((difference / duration) * 50)

  function scroll(start: number, end: number, step: number) {
    if (start === end) {
      endCallback && endCallback()
      return
    }

    let d = start + step > end ? end : start + step
    if (start > end) {
      d = start - step < end ? end : start - step
    }

    if (el === window) {
      window.scrollTo(d, d)
    } else {
      (el as HTMLElement).scrollTop = d
    }
    window.requestAnimationFrame(() => scroll(d, end, step))
  }
  scroll(from, to, step)
}

// judge JSON string
export function isJsonString(v: string) {
  if (!v) return false
  let first = v[0]
  let last = v[v.length - 1]
  return (first === '{' && last === '}') || (first === '[' && last === ']')
}

// 赋值 source 对象的部分属性
export function copyFields<K extends U, U>(target: K, source: U): K {
  for (let id in target) {
    target[id] = (<K>source)[id]
  }
  return target
}

export const datetimeOption = (unit: string) => {
  let arr: string[] = []
  let startDate
  let endDate
  switch (unit) {
    case 'week':
      startDate = moment()
        .week(moment().week())
        .startOf('week')
        .format('YYYY-MM-DD') // 本周开始日期
      endDate = moment()
        .week(moment().week())
        .endOf('week')
        .format('YYYY-MM-DD') // 时间格式 结束日期
      arr = [startDate, endDate]
      break
    case 'month':
      startDate = moment()
        .month(moment().month())
        .startOf('month')
        .format('YYYY-MM-DD')
      endDate = moment()
        .month(moment().month())
        .endOf('month')
        .format('YYYY-MM-DD')
      arr = [startDate, endDate]
      break
    case 'year':
      startDate = moment()
        .year(moment().year())
        .startOf('year')
        .format('YYYY-MM-DD')
      endDate = moment()
        .year(moment().year())
        .endOf('year')
        .format('YYYY-MM-DD')
      arr = [startDate, endDate]
      break
    default:
      break
  }
  return arr
}

/**
 * 向前移动
 * @param {*} arr 数组
 * @param {*} index 移动元素的下标
 */
export const frontMove = (arr:any[], index: number) => {
  if (index < 1) return arr
  arr[index] = arr.splice(index - 1, 1, arr[index])[0]
  return arr
}

/**
 * 向后移动
 * @param {*} arr 数组
 * @param {*} index 移动元素的下标
 */
export const backMove = (arr:any[], index: number) => {
  if (index >= arr.length - 1) return arr
  arr[index] = arr.splice(index + 1, 1, arr[index])[0]
  return arr
}

export const getPackageSize = (size: number) => (size / 1024 / 1024).toFixed(2)

/**
 * @description: 随机从数组中抽取一个元素
 * @param {any} arr
 * @return {*}
 */
export const randomOne = (arr: any[]) => arr[Math.floor(Math.random() * arr.length)]

export const confirmMiddleWare = (fn: Function, { text, title, config }: any) => {
  MessageBox.confirm(text, title, config).then(() => {
    fn && fn()
  }).catch(() => {})
}

export function sizeTostr(size: number) {
  var data = ''
  if (size < 0.1 * 1024) {
    data = size.toFixed(2) + 'B'
  } else if (size < 0.1 * 1024 * 1024) {
    data = (size / 1024).toFixed(2) + 'KB'
  } else if (size < 0.1 * 1024 * 1024 * 1024) {
    data = (size / 1024).toFixed(2) + 'KB'
  } else {
    data = (size / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
  }
  var sizestr = data + ''
  var len = sizestr.indexOf('.')
  var dec = sizestr.substr(len + 1, 2)
  if (dec === '00') {
    return sizestr.substring(0, len) + sizestr.substr(len + 3, 2)
  }
  return sizestr
}
